// Pluralize a word based on count
export const pluralize = (count: number, singular: string): string => {
  if (count === 1) return singular;
  if (/[^aeiou]y$/i.test(singular)) {
    return `${singular.slice(0, -1)}ies`;
  }
  return `${singular}s`;
};

// Helper for the common pattern where single-item changes are shown in titleElement
// and should skip detailed rendering to avoid duplication.
// Returns true when exactly one item was added OR removed (but not both).
export function shouldSkipDetailedRender(
  addedCount: number,
  removedCount: number,
): boolean {
  return (
    (addedCount === 1 && removedCount === 0) ||
    (removedCount === 1 && addedCount === 0)
  );
}
